var CommunicationModalModule = /** @class */ (function () {
    function CommunicationModalModule() {
    }
    return CommunicationModalModule;
}());
export { CommunicationModalModule };
